import React from 'react'
import { Snackbar, Portal } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';

function SnackbarOmni(props) {
    const { message, customStyles, trigger } = props;

    const [snackbaropen, setSnackBarOpen] = React.useState(false);
    const [snackbarmessage, setSnackBarMessage] = React.useState('');

    React.useEffect(() => {
        if (message) {
            setSnackBarOpen(true);
            setSnackBarMessage(message);
        }
    }, [trigger]);

    const handleCloseSnackbar = () => {
        setSnackBarOpen(false);
        setSnackBarMessage('');
    };

    return (
        <Portal>
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                open={snackbaropen}
                autoHideDuration={3000}
                onClose={handleCloseSnackbar}
                style={{ zIndex: 99999999, position: "fixed" }}
            >
                <Alert variant="filled" severity={props.color ? props.color : "success"} style={customStyles}>
                    {snackbarmessage}
                </Alert>
            </Snackbar>
        </Portal>
    )
}

export default SnackbarOmni